import ReactGA from 'react-ga';

const useSubmitProvidersSearchFilterAnalytics = () => {
    return (filters) => {
        for (const filter of Object.values(filters)) {
            if (filter.touched && filter.valid) {
                switch (filter.type) {
                    case 'order':
                        if (true) {
                        }
                        break
                    case 'multi-select':
                        switch (filter.config.variant) {
                            case 'list':
                                if (true) {
                                    for (const entry in filter.value) {
                                        ReactGA.event({
                                            category: 'Providers Search',
                                            action: 'Used a Filter Field in Query',
                                            label: filter.APIField ? filter.APIField: 'unknown',
                                            value: entry.value
                                        });
                                    }
                                }
                                break
                            case 'dropdown':
                                if (true) {
                                    for (const entry of filter.value) {
                                        ReactGA.event({
                                            category: 'Providers Search',
                                            action: 'Used a Filter Field in Query',
                                            label: filter.APIField ? filter.APIField: 'unknown',
                                            value: entry.value
                                        });
                                    }
                                }
                                break
                            default:
                                break
                        }
                        break
                    case 'single-select':
                        switch (filter.config.variant) {
                            case 'list':
                                if (true) {
                                    ReactGA.event({
                                        category: 'Providers Search',
                                        action: 'Used a Filter Field in Query',
                                        label: filter.APIField ? filter.APIField: 'unknown',
                                        value: filter.value
                                    });
                                }
                                break
                            case 'dropdown':
                                if (true) {
                                    if (filter.value) {
                                        ReactGA.event({
                                            category: 'Providers Search',
                                            action: 'Used a Filter Field in Query',
                                            label: filter.APIField ? filter.APIField: 'unknown',
                                            value: filter.value
                                        });
                                    }
                                }
                                break
                            default:
                                break
                        }
                        break
                    case 'range':
                        if (true) {


                        }
                        break
                    default:
                        break
                }
            }
        }
    }
}

export default useSubmitProvidersSearchFilterAnalytics;
